import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ConfigurationProjectState {
  storedActiveSettingsId: number | null;
}

interface ConfigurationState {
  [projectId: string]: ConfigurationProjectState;
}

const initialState: ConfigurationState = {};

const configurationSlice = createSlice({
  name: 'configurationSlice',
  initialState,
  reducers: {
    setStoredActiveSettingsId: (
      state,
      action: PayloadAction<{ id: string; storedActiveSettingsId: number | null }>,
    ) => {
      state[action.payload.id] = state[action.payload.id] || { storedActiveSettingsId: null };
      state[action.payload.id].storedActiveSettingsId = action.payload.storedActiveSettingsId;
    },
  },
});

export const { setStoredActiveSettingsId } = configurationSlice.actions;
export default configurationSlice.reducer;
